import { readableDeviceName } from '@iotv/core-services';
import { roundDecimals } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { deviceState, PayloadDataGridCell, wrapLink, WrapLinkVOB } from '../../../factories/DataGrid';
import { signalAttributeColor } from '../../../factories/DataGrid/cellFormatters/rangeColors';
import { NavSections } from '../../../navigation/NavSections';
import { trueIsGood, trueIsYes, updown } from '../../cellFormatters/boolean';
import { filterUD } from '../../cellFormatters/filterFormatters';
import { dateTimeNow, NWName, voltageToPercentage } from '../../cellFormatters/valueFormatters';
export const columnMap = {
    timestamp: {
        headerName: 'Time',
        width: 160,
        sortable: true,
        valueFormatter: dateTimeNow,
    },
    // Customers
    customerName: {
        headerName: 'Customer',
        width: 120,
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'customerSk'),
    },
    propertyName: {
        headerName: 'Property',
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'propertySk'),
    },
    groupName: {
        headerName: 'Group',
        width: 120,
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'groupSk'),
    },
    entityName: {
        headerName: 'Entity',
        minWidth: 140,
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'entitySk'),
    },
    devState: {
        headerName: 'State',
        minWidth: 50,
        sortable: false,
        renderCell: deviceState,
    },
    nwID: {
        headerName: 'Network',
        width: 80,
        sortable: false,
        valueFormatter: NWName,
    },
    nasSourceIp: {
        headerName: 'NAS IP',
        width: 110,
        sortable: false,
    },
    app_id: {
        headerName: 'AS',
        width: 100,
        sortable: false,
    },
    // Gateway
    gatewayEui: {
        headerName: 'Gateway',
        width: 145,
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'gatewaySk'),
    },
    gatewayLat: {
        headerName: 'GW lat',
        width: 80,
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 5) : value),
    },
    gatewayLng: {
        headerName: 'GW lng',
        width: 80,
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 5) : value),
    },
    gatewayDOP: {
        headerName: 'GW DoP',
        width: 80,
        sortable: true,
    },
    // Devices
    deviceEui: {
        headerName: 'EUI',
        minWidth: 145,
        sortable: false,
        renderCell: (p) => WrapLinkVOB(p, 'deviceSk'),
    },
    deviceLat: {
        headerName: 'Device lat.',
        width: 100,
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 5) : value),
    },
    deviceLng: {
        headerName: 'Device lng.',
        width: 100,
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 5) : value),
    },
    devDoP: {
        headerName: 'DDoP',
        width: 60,
        sortable: true,
    },
    /** RSE suppressed these as are misleading, they are OK in a device summary table (if labelled correctly) but not in a per message table */
    /*
  devFCntJumpDaily: {
    headerName: 'fCntJump',
    width: 80,
    valueFormatter: (value, row, column, apiRef) => (isNumber(value) ? roundDecimals(value, 5) : value),
  },
  devMessageCntDaily: {
    headerName: 'msgCnt',
    width: 80,
    valueFormatter: (value, row, column, apiRef) => (isNumber(value) ? roundDecimals(value, 5) : value),
  },
  ystrdayMsgCntJump: {
    headerName: 'yesterdaysMessageCntTotal',
    width: 80,
    valueFormatter: (value, row, column, apiRef) => (isNumber(value) ? roundDecimals(value, 5) : value),
  },
  ystrdayFCntJump: {
    headerName: 'yesterdaysFCntJumpTotal',
    width: 80,
    valueFormatter: (value, row, column, apiRef) => (isNumber(value) ? roundDecimals(value, 5) : value),
  },
  */
    battery: {
        headerName: 'Battery (%)',
        width: 90,
        align: 'center',
        sortable: true,
        valueFormatter: voltageToPercentage,
    },
    batteryV: {
        headerName: 'Battery (V)',
        width: 90,
        align: 'center',
        sortable: true,
    },
    batteryCharging: {
        headerName: 'Charging?',
        width: 80,
        align: 'center',
        sortable: false,
        renderCell: trueIsGood,
    },
    temperature: {
        headerName: 'Temperature',
        width: 90,
        align: 'center',
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? `${value}℃` : undefined),
    },
    humidity: {
        headerName: 'Humidity',
        width: 80,
        align: 'center',
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? `${value}%` : undefined),
    },
    deviceType: {
        headerName: 'Type',
        width: 100,
        sortable: false,
        valueGetter: (value) => (value ? readableDeviceName(value) : `-`),
    },
    // devFrequence: {
    // headerName: 'Freq',
    // minWidth:40,
    // },
    // devUp: {
    //   headerName: 'DevUps',
    //   minWidth: 40,
    // },
    // devDown: {
    //   headerName: 'DevDowns',
    //   minWidth: 40,
    // },
    // devJoins: {
    //   headerName: 'Joins',
    //   minWidth: 40,
    // },
    // downlinkAck: {
    //   headerName: 'ACK',
    //   width: 50,
    //   align: 'center',
    //   renderCell: trueIsYes,
    // },
    // Reception
    distance: {
        headerName: 'kM',
        width: 60,
        sortable: true,
    },
    consumedAirtimeSecs: {
        headerName: 'AT',
        width: 30,
        align: 'center',
        sortable: true,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 3) : undefined),
        renderCell: signalAttributeColor,
    },
    esp: {
        headerName: 'ESP',
        width: 30,
        align: 'center',
        sortable: true,
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
    rssi: {
        headerName: 'RSSI',
        width: 60,
        align: 'center',
        sortable: true,
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
    snr: {
        headerName: 'SNR',
        width: 30,
        align: 'center',
        sortable: true,
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
    sf: {
        headerName: 'SF',
        width: 30,
        align: 'center',
        sortable: true,
        renderCell: signalAttributeColor,
    },
    power: {
        headerName: 'Power',
        width: 60,
        align: 'center',
        sortable: true,
        renderCell: signalAttributeColor,
    },
    port: {
        headerName: 'Port',
        width: 30,
        sortable: true,
    },
    frequency: {
        headerName: 'Freq.',
        width: 60,
        sortable: false,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value > 1000000 ? value / 1000000 : value, 2) : undefined),
    },
    channel: {
        headerName: 'Ch.',
        width: 20,
        sortable: false,
    },
    // Message
    linkType: {
        headerName: 'U/D',
        width: 20,
        align: 'center',
        sortable: false,
        renderCell: updown,
        filterOperators: filterUD,
    },
    fCnt: {
        headerName: 'Frame',
        width: 60,
        sortable: true,
    },
    /** RSE Readded to cross check with actual data */
    fCntInc: {
        headerName: 'Dropped',
        width: 70,
        sortable: true,
        valueGetter: (value, row, column, apiRef) => (isNonNaNNumber(row.fCntInc) && row.fCntInc - 1 > 0 ? row.fCntInc - 1 : '-'),
    },
    GtD: {
        headerName: 'Gateway to Device',
        width: 130,
        sortable: true,
        valueGetter: (value, row, column, apiRef) => (isNonNaNNumber(row.GtD) ? roundDecimals(row.GtD, 1) : ''),
    },
    DBear: {
        headerName: 'Device bearing',
        width: 120,
        sortable: false,
        valueGetter: (value, row, column, apiRef) => (isNonNaNNumber(row.DBear) ? roundDecimals(row.DBear, 1) : ''),
    },
    DtG: {
        headerName: 'Device to Gateway',
        width: 130,
        sortable: true,
        valueGetter: (value, row, column, apiRef) => (isNonNaNNumber(row.DtG) ? roundDecimals(row.DtG, 1) : ''),
    },
    size: {
        headerName: 'Size',
        width: 40,
        sortable: true,
    },
    payloadStr: {
        headerName: 'Payload',
        minWidth: 400,
        flex: 1,
        sortable: false,
        renderCell: (p) => PayloadDataGridCell(p),
    },
    // OTHER
    // bw: {
    //   headerName: 'BW',
    //   width: 75,
    // },
    // adr: {
    //   headerName: 'ADR',
    //   width: 75,
    // },
    // dr: {
    //   headerName: 'DR',
    //   width: 75,
    // },
    // codeRate: {
    //   headerName: 'CODE RATE',
    //   width: 150,
    // },
    // batteryErr: {
    //   headerName: 'BAT ERR?',
    //   align: 'center',
    //   renderCell: trueIsBad,
    // },
    // linkCheckErr: {
    //   headerName: 'LINK ERR?',
    //   align: 'center',
    //   renderCell: trueIsBad,
    // },
    // reboot: {
    //   headerName: 'REBOOT?',
    //   align: 'center',
    //   renderCell: reboot,
    // },
};
export const gatewayColumnMap = {
    timestamp: {
        headerName: 'Time',
        width: 160,
        valueFormatter: dateTimeNow,
    },
    isPrimaryGateway: {
        headerName: 'Primary Gateway',
        headerAlign: 'center',
        width: 110,
        align: 'center',
        renderCell: trueIsYes,
    },
    gatewayEui: {
        headerName: 'Gateway EUI',
        width: 160,
        // renderCell: p => WrapLinkVOB(p, 'gatewayEui'),
        renderCell: (p) => (p.row[`gatewayEui`] ? wrapLink(`/${NavSections.THINGVIEW}/Gateway/${p.row[`gatewayEui`]}`)(p) : undefined),
        //
    },
    deviceEui: {
        headerName: 'Device EUI',
        width: 160,
        // renderCell: p => WrapLinkVOB(p, 'deviceEui'),
        renderCell: (p) => (p.row[`deviceEui`] ? wrapLink(`/${NavSections.THINGVIEW}/Device/${p.row[`deviceEui`]}`)(p) : undefined),
    },
    linkType: {
        headerName: 'U/D',
        headerAlign: 'center',
        width: 20,
        align: 'center',
        renderCell: updown,
    },
    app_id: {
        headerName: 'App ID',
        width: 120,
    },
    bw: {
        headerName: 'BW',
        width: 40,
    },
    dr: {
        headerName: 'DR',
        headerAlign: 'center',
        width: 40,
        align: 'center',
        renderCell: signalAttributeColor,
    },
    adr: {
        headerName: 'ADR',
        headerAlign: 'center',
        width: 40,
        align: 'center',
        renderCell: trueIsGood,
    },
    sf: {
        headerName: 'SF',
        headerAlign: 'center',
        width: 40,
        align: 'center',
        renderCell: signalAttributeColor,
    },
    codeRate: {
        headerName: 'Coding',
        headerAlign: 'center',
        width: 60,
        align: 'center',
    },
    consumedAirtimeSecs: {
        headerName: 'Airtime',
        headerAlign: 'center',
        width: 60,
        align: 'center',
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value, 3) : undefined),
        renderCell: signalAttributeColor,
    },
    fCnt: {
        headerName: 'Frame',
        width: 60,
    },
    frequency: {
        headerName: 'Freq.',
        width: 60,
        valueFormatter: (value) => (isNonNaNNumber(value) ? roundDecimals(value > 1000000 ? value / 1000000 : value, 2) : undefined),
    },
    modulation: {
        headerName: 'Modulation',
        width: 90,
    },
    nwID: {
        headerName: 'NW ID',
        width: 100,
    },
    port: {
        headerName: 'Port',
        headerAlign: 'center',
        width: 40,
        align: 'center',
    },
    // uplinkId: {
    //   headerName: 'Uplink ID',
    //   width: 140,
    // },
    esp: {
        headerName: 'ESP',
        headerAlign: 'center',
        width: 30,
        align: 'center',
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
    rssi: {
        headerName: 'RSSI',
        headerAlign: 'center',
        width: 60,
        align: 'center',
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
    snr: {
        headerName: 'SNR',
        headerAlign: 'center',
        width: 30,
        align: 'center',
        valueFormatter: (value) => (isNonNaNNumber(value) ? Math.round(value) : undefined),
        renderCell: signalAttributeColor,
    },
};
